import React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";
import { cn } from "../../../Utils/helper";

const CheckboxCommon = React.forwardRef(
    ({ className, checked, onCheckedChange, value, ...props }, ref) => (
        <CheckboxPrimitive.Root
            ref={ref}
            checked={checked}
            onCheckedChange={onCheckedChange}
            value={value}
            className={cn(
                `peer h-6 w-6 shrink-0 rounded-xl border-2 border-[]  focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-[#3F54DF] data-[state=checked]:text-white`,
                className
            )}
            {...props}
        >
            <CheckboxPrimitive.Indicator
                className={cn(
                    "flex items-center justify-center text-current w-full h-full"
                )}
            >
                <Check className="h-4 w-4 stroke-[3]" />
            </CheckboxPrimitive.Indicator>
        </CheckboxPrimitive.Root>
    )
);

CheckboxCommon.displayName = CheckboxPrimitive.Root.displayName;

export { CheckboxCommon };
